import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Modal from '../Modal/Modal';
import ZoomIcon from '../../assets/svgs/ZoomIcon';
import NoPhotoIcon from '../../assets/svgs/NoPhotoIcon';
import PauseIcon from '../../assets/svgs/PauseIcon';
import PlayIcon from '../../assets/svgs/PlayIcon';
import LoadingSection from '../../components/Loading/LoadingSection';

import translate from '../../libs/i18n';
import { useDisableBodyScroll } from '../../utils/useDisableBodyScroll';
import { Report3dVideoStyle } from './Report3dVideoStyle';

const Report3dVideo = ({ video }) => {
  const language = useSelector((state) => state.settings.language);

  const [showModal, setShowModal] = useState(false);
  const [loadingVideo, setLoadingVideo] = useState(true); 
  const [videoUnavailable, setVideoUnavailable] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);

  const videoRef = useRef(null);
  useDisableBodyScroll(showModal);

  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };


  useEffect(() => {
    if (video && video.content && video.content.length) {
      setLoadingVideo(false);
      setVideoUnavailable(false);
    } else {
      
      const timeoutId = setTimeout(() => {
        setLoadingVideo(false);
        setVideoUnavailable(true);
      }, 30000);

      return () => clearTimeout(timeoutId);
    }
  }, [video]);

  return (
    <Report3dVideoStyle>
      {loadingVideo ? (
        <div className="not-available-warning">
          <LoadingSection message={translate('loading3DModel', language)} />
        </div>
      ) : videoUnavailable ? (
        <div className="not-available-warning">
          <div style={{ display: 'flex', justifyContent: 'center'}}>
            <NoPhotoIcon /> 
          </div>
        </div>
      ) : (
        <button
          className="show-modal"
          type="button"
          onClick={() => setShowModal(true)}
        >
          <video className="report-image-file" ref={videoRef} src={video.content} loop>
            <track default kind="captions" srcLang="en" />
          </video>
          <span className="zoom-icon">
            <ZoomIcon />
          </span>
        </button>
        
      )}
      {showModal && video && video.content && video.content.length ? (
        <Modal theme="black" fullScreen handleClose={() => setShowModal(false)}>
          <>
            <video
              className="modal-image-content"
              style={{
                height: "100%",
                paddingTop: "20px",
                position: "relative",
                width: "100%"
              }}
              src={video.content}
              ref={videoRef}
              autoPlay
              loop
            >
              <track default kind="captions" srcLang="en" />
            </video>

            <button className="btn btn-secondary position-absolute bottom-0 start-50 translate-middle-x mb-5" onClick={handlePlayPause}>
                {isPlaying ? <PauseIcon></PauseIcon> : <PlayIcon></PlayIcon>}
            </button>
          </>
        </Modal>
      ) : null}
    </Report3dVideoStyle>
  );
};

Report3dVideo.propTypes = {
  video: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.shape({ content: PropTypes.string }),
  ]),
};

Report3dVideo.defaultProps = {
  video: null,
};

export default Report3dVideo;
